import classNames from "classnames";
import CardTitle from "../../../components/CardTitle";
import TMapComp, { MapRef, TextTag } from "../../../components/TMap";
import styles from "./WisdomPartyBuilding.module.scss";
import YearPicker from "../../../components/YearPicker";
import styled from "@emotion/styled";
import test1Img from "../../../images/test1.png";

import upImg from "../../../images/up.png";
import downImg from "../../../images/down.png";
import lineBoxImg from "../../../images/line-box1.png";
import line2 from "../../../images/line2.png";
import { MainLayout } from "../../../components/Layout";
import { useCallback, useEffect, useRef, useState } from "react";
import request from "../../../utils/request";
import logo from "../../../images/logo.png";
import { LiveTime } from "../../../components/LiveTime/index";
import { CommonModal } from "./Modals/Common/CommonModal";
import { appConfigs } from "../../../config";
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
const globalMap: any = TMap as any;
const areaMapping = {
  西片区: [
    {
      title: "第一网格",
      zuzhang: "许培贤",
      qiantouren: "梁骏",
      zerenbumen: "应急管理和生态环境局、财政金融局",
      fuzefanwei: "205国道沿线、三台创业园及化工园区、雨山经开区向山片区全域",
    },
    {
      zuzhang: "张杰",
      title: "第五网格",
      qiantouren: "徐成伟",
      zerenbumen: "城管中队",
      fuzefanwei: "雨田路859大院、所有4s店区域",
    },
  ],
  南片区: [
    {
      title: "第二网格",
      zuzhang: "张娟",
      qiantouren: "冯曼曼",
      zerenbumen: "经济发展局",
      fuzefanwei: "雨山经济开发区西区九华西路以北（不含佳达工业园）区域",
    },
    {
      title: "第三网格",
      zuzhang: "高瑞",
      qiantouren: "夏华泽",
      zerenbumen: "企业服务局",
      fuzefanwei: "雨山经济开发区西区九华西路以南及佳达工业园区域",
    },
  ],
  东片区: [
    {
      title: "第四网格",
      zuzhang: "陶勇",
      qiantouren: "李鹏",
      zerenbumen: "规划建设局",
      fuzefanwei: "雨山经济开发区东区全域",
    },
  ],
} as any;

const ParkOverviewLayout = styled.div`
  .left {
    width: 458px !important;
    background-size: cover;

    .overriew {
      padding-right: 40px;
      .overriew-text {
        margin-top: 15px;
      }
      p {
        font-size: 18px;
        line-height: 28px;
        color: #1cfbff;
      }
    }
  }
  .panel {
    margin-top: 52px;
    .panel-item {
      height: 36px;
      align-items: center;

      display: flex;
      list-style: none;
      font-size: 16px;
      color: #7bbcee;
      &:nth-child(odd) {
        background-image: url(${lineBoxImg});
      }
      &-v {
        flex: 1;
        text-align: center;
      }
    }
  }
  .area {
    padding-right: 47px;
    padding-left: 20px;
    .area-item {
      color: #b2dcfd;
      margin: 35px 0;
      font-size: 18px;
      .label-box {
        align-items: center;
      }
      .label {
        color: #fff;
        margin-left: 21px;
        font-size: 24px;
      }
      .area-value {
        margin-top: 25px;
        line-height: 25px;
      }
    }
  }
  .no-data {
    color: #b2dcfd;
    text-align: center;
    list-style: none;
    padding: 10px 0;
  }
`;

const ParkOverview: React.FC = () => {
  const [panelData, setPanelData] = useState<any[]>([]);
  const [open, setOpen] = useState(false);
  const [currentRecord, setCurrentRecord] = useState<any>();
  const [currentYear, setCurrentYear] = useState(
    new Date().getFullYear().toString()
  );
  const [areaTextList, setAreaTextList] = useState<any[]>([]);
  const [gisDatas, setGisDatas] = useState<any[]>([]);
  const [isInitGis, setIsInitGis] = useState(false);
  const [area, setArea] = useState("");
  const gisRef = useRef<any>();
  const getData = useCallback(async () => {
    try {
      const res = await request(
        `/screen/Index/getBoardInfo?years=${currentYear}`
      );
      setPanelData(res.data.data);
    } catch (e) {
      console.error(e);
    }
  }, [currentYear]);

  const getPlanning = useCallback(async () => {
    try {
      const res = await request(`/screen/Index/getPlanning`);
      const location = res.data.data.location;
      setArea(res.data.data.area || "");
      const tempArr: object[] = [];
      location.forEach((l: any) => {
        if (l.gisdata) {
          const gisArr = JSON.parse(l.gisdata);
          gisArr.map((gis: string, index: number) => {
            tempArr.push({
              gisdata: JSON.stringify([gis]),
              label: l.title,
              desc: l.desc,
              id: l.id,
              record: areaMapping[l.title as string]?.[index] as any,
              onClick: (record: any) => {
                setCurrentRecord(record);
                setOpen(true);
              },
            });
          });
        }
      });
      gisRef.current = tempArr;
      setGisDatas(tempArr);
      setAreaTextList(location);
    } catch (e) {
      console.error(e);
    }
  }, []);
  useEffect(() => {
    getPlanning();
  }, [getPlanning]);
  useEffect(() => {
    getData();
  }, [getData]);

  const mapRef = useRef<MapRef | null>(null);
  const mapPos: TextTag[] = (appConfigs.mapPos as TextTag[]) || [
    {
      name: "上海市，332KM",
      key: "sh",
      position: [121.473297, 31.229329],
    },
    {
      name: "杭州市，289KM",
      key: "hz",
      position: [120.209684, 30.244109],
    },
    {
      name: "长三角经济圈",
      key: "csj",
      position: [120.318045, 31.486153],
    },
    {
      name: "南京市，60KM",
      key: "nj",
      position: [118.798945, 32.057936],
    },
    {
      name: "芜湖，51KM",
      key: "wh",
      position: [118.435962, 31.357089],
    },
    {
      name: "雨山经济开发区",
      key: "ys",
      position: [118.550572, 31.644232],
    },
  ];

  const [zoom, setZoom] = useState(14.2);
  const goToArea = (item: any) => {
    mapRef.current?.zoomTo?.(zoom);
    const itemGisData = JSON.parse(item.gisdata || "[]");

    if (itemGisData.length) {
      const item = itemGisData[0];
      const center = item.geometry.center;
      setTimeout(() => {
        if (center) {
          mapRef.current?.panTo?.(center.lat, center.lng);
        } else {
          if (item.geometry.paths?.length) {
            // 计算多边形形心
            var position = globalMap.geometry.computeCentroid(
              item.geometry.paths.map(
                (item: any) => new globalMap.LatLng(item.lat, item.lng)
              )
            );
            mapRef.current?.panTo?.(position.lat, position.lng);
          }
        }
      }, 1000);
    }
  };
  useEffect(() => {
    if (mapRef.current) {
      mapRef.current.panTo?.(31.486153, 120.318045);
    }
  }, []);
  const renderGis = () => {
    if (!isInitGis) {
      mapRef.current?.setMarkers?.(false, gisRef.current);
    }
    setIsInitGis(true);
  };
  return (
    <ParkOverviewLayout>
      <div className={styles.commonBox}>
        <div className={styles.WisdomPartyBuilding}>
          <LiveTime />
          <MainLayout
            leftWidth={458}
            left={
              <div className={classNames(styles.leftContainer, "left")}>
                <div className={classNames(styles.flex, styles.cardTitle)}>
                  <CardTitle
                    titleStyles={{
                      paddingLeft: 65,
                    }}
                    title="园区总览"
                  />
                </div>
                <div className="overriew">
                  <img
                    src={appConfigs.parkLogo || test1Img}
                    alt=""
                    style={appConfigs.parkLogoStyle || {}}
                  />
                  <div className="overriew-text">
                    <p>
                      {appConfigs.parkDesc ||
                        `安徽马鞍山雨山经济开发区是在2002年市政府批准建设的雨山工业园基础上扩建而成，2010年10月
                      获省政府批准筹建省级开发区，2018年7月被省政府正式批准为省级开发区。园区实际建成区面积10.66平方公里，由东、南、西、北四大片区组成，形成了功能性材料主导产业集群。`}
                    </p>
                    <p style={{ margin: "30px 0" }}>
                      {area
                        ? `园区批复面积: ${area}`
                        : appConfigs.mianji || "园区批复面积:470.12公顷"}
                    </p>
                    <p>
                      {" "}
                      {appConfigs.hangye ||
                        "产业定位：装备制造、电子信息、节能环保"}{" "}
                    </p>
                  </div>
                </div>

                <div className="panel">
                  <div className={styles.flex}>
                    <div className={classNames(styles.flex, styles.cardTitle)}>
                      <CardTitle
                        titleStyles={{
                          paddingLeft: 65,
                        }}
                        title="运营看板"
                      />
                      <YearPicker
                        // defaultValue={new Date().getFullYear().toString()}
                        defaultValue={currentYear}
                        onChange={(e, dateStr) => {
                          setCurrentYear(dateStr);
                        }}
                      />
                    </div>
                  </div>
                  <ul>
                    {panelData.length === 0 ? (
                      <li className="no-data">暂无数据</li>
                    ) : (
                      panelData.map((item, index) => {
                        return (
                          <li className="panel-item" key={index}>
                            <div className="panel-item-v">{item.title}</div>
                            <div className="panel-item-v">
                              {item.value}
                              {item.unit}
                            </div>
                            <div className="panel-item-v">
                              <span>{item.amp}%</span>
                              <img
                                src={item.amp < 0 ? downImg : upImg}
                                alt=""
                              />
                            </div>
                          </li>
                        );
                      })
                    )}
                  </ul>
                </div>
              </div>
            }
            rightWidth={466}
            right={
              <div className={styles.rightContainer}>
                <CardTitle
                  titleStyles={{
                    paddingLeft: 65,
                  }}
                  title="区位规划"
                />
                <div className="area">
                  {areaTextList.map((item, index) => {
                    return (
                      <div className="area-item" key={index}>
                        <div
                          className={classNames(styles.flex, "label-box")}
                          style={{
                            alignItems: "normal",
                            justifyContent: "normal",
                          }}
                        >
                          <img src={line2} width={4} alt="" />
                          <span
                            className="label"
                            style={{ cursor: "pointer" }}
                            onClick={() => {
                              goToArea(item);
                              renderGis();
                            }}
                          >
                            {item.title}
                          </span>
                        </div>
                        <p className="area-value">{item.desc}</p>
                      </div>
                    );
                  })}
                </div>
              </div>
            }
            map={
              <TMapComp
                isFullScreen
                ref={mapRef}
                zoom={appConfigs.zoom || 7.6}
                textTag={[...mapPos]}
                // initialValues={gisDatas}
                iconTextTag={[
                  {
                    name: `
                    <div style="position: relative;z-index: 1;transform: translateY(-98px) translateX(-10px); display: flex; flex-direction: column; align-items: center">
                      <span style="color: #333; padding: 8px; 10px; background: #00DEFF; border-radius: 20px">雨山经济开发区管委会</span>
                      <img src=${logo} width="30" />
                    </div>`,
                    position: (appConfigs.position as [number, number]) || [
                      118.550572, 31.644232,
                    ],
                    isBg: false,
                  },
                ]}
                ellipseGeometry={
                  appConfigs.ellipseGeometry || [
                    {
                      styleId: "default",
                      center: new globalMap.LatLng(31.482396, 116.963646),
                      majorRadius: 204995.0115843598,
                      minorRadius: 153292.83951097802,
                    },
                  ]
                }
                onGeometryClick={(tag) => {
                  if (tag?.key === "ys") {
                    mapRef.current?.zoomTo?.(zoom);

                    setTimeout(() => {
                      mapRef.current?.panTo?.(
                        tag!.position[1],
                        tag!.position[0]
                      );
                      renderGis();
                    }, 1000);
                  }
                }}
              />
            }
          >
            <CommonModal
              type={"areaInfo"}
              visible={open}
              setVisible={setOpen}
              // param={param}
              title={"区域信息"}
              // goToDetail={goToDetail}
              currentRecord={currentRecord}
            />
          </MainLayout>
        </div>
      </div>
    </ParkOverviewLayout>
  );
};

export default ParkOverview;
